(function( $ ) {
	$(function() {

        // toggle menu icon
        $('.menu-icon').on('click', function () {
        	$(this).addClass('opened');
        });

        //Sliders
        $('.flex_slider').slick({
        	cssEase: 'ease',
        	fade: true,
        	dots: true,
        	speed: 500,
        	arrows: false,
        	slideToShow: 1,
        	slidesToScroll: 1,
        	slide: '.flex_slide'
        });

        $('.triple_slider').slick({
        	cssEase: 'ease',
        	fade:false,
        	dots:true,
        	speed:500,
        	arrows: false,
        	slidesToShow: 3,
        	slidesToScroll: 1,
        	autoplaySpeed: 2000,
            responsive:[
                {
                    breakpoint:1024,
                    settings:{
                        slidesToShow:2,
                        slidesToScroll:1
                    }
                }
            ]
        });
        $('.logos-slider').slick({
            autoplay: true,
            infinite: true,
            cssEase: 'ease',
            fade:false,
            dots:false,
            speed:500,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            autoplaySpeed: 2000,
            responsive:[
                {
                    breakpoint:1024,
                    settings:{
                        slidesToShow:3,
                        slidesToScroll:3
                    }
                },
                {
                    breakpoint:768,
                    settings:{
                        slidesToShow:2,
                        slidesToScroll:2
                    }
                },
                {
                    breakpoint:641,
                    settings:{
                        slidesToShow:1,
                        slidesToScroll:1
                    }
                }
            ]
        });

		//Make elements equal height
		$('.text_with_small_image .small_block > div').matchHeight();

        // Scroll To Top button
        $('.scrollToTop').click(function(){
        	$('html, body').animate({scrollTop : 0},1000);
        	return false;
        });

        //Disable video Overlay
        $('.video .embed-container .overlay_icon img').click(function() {
        	$('.video .embed-container .overlay').hide();
        });

        //Don't follow current language
        $('.current-language').on('click', function(e){
        	e.preventDefault();
        });
        //Toggle Languages
        $('.language-select').on('click', function(e){
        	if( $(this).hasClass('opened') ){
        		$('.other-languages').hide();
        		$('.language-select').removeClass('opened');
        	}
        	else {
        		$(this).addClass('opened');
        		$('.other-languages').show();
        	}
        });
        $(document).on('click touchstart', function(event){
        	if(!$(event.target).closest('.language-select').length) {
        		if($('.other-languages').is(":visible")) {
        			$('.other-languages').hide();
        			$('.language-select').removeClass('opened');
        		}
        	}
        });

    //Mobile menu
    $('.menu-icon, .castom-menu-icon').click(function(){
        $('body').toggleClass('menu-open');
        $('html').toggleClass('no-scroll');
    });
    //Home animation
    $('.header__banner.home .header__banner-content').animate({
            'opacity':1
        },
            1000, function(){
        $(this).find('strong').addClass('large');
    });
    //header__banner padding
    function calcBannerPadding(){
        if( $('.header__banner .sub_menu').length > 0 ){            
            if( $(window).width() > 1024 ){
                var subsTopPadding = 0;
                $('.header__banner .sub_menu').each(function(){
                    subsTopPadding = subsTopPadding + $(this).outerHeight();
                });
                $('.header__banner').css('padding-top', subsTopPadding+'px');
            }
            else {
                $('.header__banner').css('padding-top', '0px');
            }
        }
        else {            
            $('.header__banner').addClass('no-sub');
        }
    }
    calcBannerPadding();
    $(window).resize(function(){        
        calcBannerPadding();
    });
    
    var header_height; 
    var footer_height;
    var sumHeights;
    function set404Height(){
        header_height = $('.top_bar').height();
        footer_height = $('footer').height();    
        sumHeights = header_height + footer_height;
        $('.error404 .main').css('min-height', 'calc(100vh - '+sumHeights+'px)');
    }
    set404Height();
    $(window).resize(function(){
        set404Height();
    });
    $('.team__member').matchHeight();
    $('.header__banner .matchHeight').matchHeight();
    
});
})(jQuery);
